import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  FETCH_CAMPAIGNS,
  FETCH_CAMPAIGNS_SUCCESS,
  FETCH_CAMPAIGNS_FAIL
} from '../../constants';

const fetchCampaigns = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_CAMPAIGNS),
    switchMap(action => {

      return ajax({
        url:  `${state$.value.auth.server}/campaigns?type=audienceSummary`,
        headers: {
          Authorization: state$.value.auth.token,
          'Content-Type': 'application/json',
        },
        responseType: 'json',
        crossDomain: true,
        method: 'GET',
      }).pipe(
        map(response => {

          return {
            type: FETCH_CAMPAIGNS_SUCCESS,
            data: response.response
          };
        }),
        catchError(error => {
          console.log(error);
        })
      );
    })
  );

export default fetchCampaigns;
